export const resources = {
    en: {
        translation: {
            example: 'example213123',
            JanFull: 'Januray',
        },
    },
    th: {
        translation: {
            example: 'example-2',
            JanFull: 'Januray',
        },
    },
}
